import React from 'react';

interface TrashOutlineIconProps {
  size?: number;
  color?: string;
}

const TrashOutlineIcon: React.FC<TrashOutlineIconProps> = ({
  size = 20,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.83862 4.82245H16.1615"
      stroke={color}
      strokeWidth="1.29"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.62891 4.82245H14.371V15.5646C14.371 15.8811 14.2452 16.1848 14.0215 16.4086C13.7977 16.6324 13.494 16.7582 13.1775 16.7582H4.82248C4.50592 16.7582 4.20233 16.6324 3.97849 16.4086C3.75466 16.1848 3.62891 15.8811 3.62891 15.5646V4.82245Z"
      stroke={color}
      strokeWidth="1.29"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.01611 4.82247V4.22569C6.01611 3.4343 6.33049 2.67532 6.89008 2.11573C7.44968 1.55614 8.20866 1.24176 9.00004 1.24176C9.79143 1.24176 10.5504 1.55614 11.11 2.11573C11.6696 2.67532 11.984 3.4343 11.984 4.22569V4.82247"
      stroke={color}
      strokeWidth="1.29"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.20972 8.40491V13.181"
      stroke={color}
      strokeWidth="1.29"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7905 8.40491V13.181"
      stroke={color}
      strokeWidth="1.29"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TrashOutlineIcon;
